import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { AirfoilStyles } from "../AirfoilStyles/index.js";
import { cn as clsx } from "../../helpers/react.js";
const withThemeAndSize = (Wrapped) => {
  const ComponentWithThemeAndSize = forwardRef((props, ref) => {
    const { size, theme, className, ...restProps } = props;
    const themeClass = AirfoilStyles.getThemeClassName(theme);
    const sizeClass = AirfoilStyles.getSizeClassName(size);
    const derivedClassName = clsx(themeClass, sizeClass, className);
    return /* @__PURE__ */ jsx(Wrapped, { ...restProps, className: derivedClassName, ref, size, theme });
  });
  ComponentWithThemeAndSize.displayName = `WithThemeAndSize(${Wrapped.displayName || Wrapped.name || "Component"})`;
  return ComponentWithThemeAndSize;
};
const ThemeSlot = forwardRef(
  ({ size, theme, className, children, ...rest }, ref) => {
    const themeClass = AirfoilStyles.getThemeClassName(theme);
    const sizeClass = AirfoilStyles.getSizeClassName(size);
    return /* @__PURE__ */ jsx(Slot, { ...rest, className: clsx(themeClass, sizeClass, className), ref, children });
  }
);
export {
  ThemeSlot,
  withThemeAndSize
};
